export function replaceWithEnDash(input: string): string {
  // Regex to find patterns like "DE - Deutsch", "DE–Deutsch", etc.
  // and replace them with "DE – Deutsch"
  return input.replace(/(\b\w+)\s*[-–—]\s*(\w+\b)/g, '$1 – $2');
}
